import React from 'react';
import styled from 'styled-components';

const Header = styled.div`
  width: 100%;
  background-color: #182231;
  box-shadow: 0 12px 24px 0 #0F1927;
  position: relative;
`;

export default Header;
